

















































import { defineComponent, PropType, toRefs, computed, ref, ComputedRef } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  FullNormalFormData,
  IdentityInfo,
  SpuInfo,
  ShopListItem,
  PRODUCTS_PSA_MAX_NUM,
  PRODUCTS_MAX_NUM,
} from '@tt4b/ttam-enums';
import {
  useProductsList,
  usePagianation,
  usePageCount,
  useSearchCondition,
  useExpandRow,
  useSelectRow,
  useSpuFilter,
  spuListAmountType,
} from '../hooks';
import ProductSearch from './product-search.vue';
import ProductTable from './product-table.vue';
import ShopEmptySvg from '@tt4b/ttam-assets/src/svgs/creative/shop-empty.svg';
import { isEmpty } from 'lodash-es';
import { useStdCreativeAdgroupIs } from '@tt4b/ttam-hooks';

const SORT_FIELD_MAP = {
  default: 0,
  price: 1,
  total_sales: 9,
};

const name = 'ttam-product-select-from-shop-main';
export default defineComponent({
  name,
  components: {
    ProductSearch,
    ProductTable,
    ShopEmptySvg,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
    },
    selectedSpuList: {
      type: Array as PropType<Array<SpuInfo>>,
      required: true,
    },
    shopInfo: {
      type: Object as PropType<ShopListItem>,
      required: true,
    },
    identity: {
      type: Object as PropType<IdentityInfo>,
      optional: true,
    },
    location: {
      type: Array as PropType<Array<string>>,
      optional: true,
    },
    isEcomShop: {
      type: Boolean,
      required: true,
    },
    isSingleSelect: {
      type: Boolean,
      default: false,
    },
    spuListAmount: {
      type: Object as PropType<spuListAmountType>,
      default: () => ({
        allAmount: 0,
        availableAmount: 0,
      }),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, selectedSpuList, identity, location, shopInfo, isEcomShop, isSingleSelect } =
      toRefs<{
        adgroupData: AdgroupFormData;
        campaignData: CampaignFormData;
        selectedSpuList: Array<SpuInfo>;
        shopInfo: ShopListItem;
        identity?: IdentityInfo;
        location?: Array<string>;
        isEcomShop: boolean;
        isSingleSelect?: boolean;
      }>(props);

    const { handlePageChange, currentPage } = usePagianation();
    const { is1pShop, isProductFromShowcase } = useStdCreativeAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });

    const { search, fieldList } = useSearchCondition(isEcomShop as ComputedRef<boolean>);

    const sortParam = ref({
      sort_order: 0,
      sort_field: SORT_FIELD_MAP.total_sales,
    });

    const {
      spuAvailableFilter,
      spuAvailableFilterChange,
      spuAvailableParams,
      inStorefrontFilter,
      inStorefrontFilterChange,
      spuInStorefrontParams,
    } = useSpuFilter(currentPage);

    // 1p 的shop、showcase才能用新接口获取商品列表
    const useNewSearchApi = computed(() => isProductFromShowcase.value || is1pShop.value);

    const isNeedMutexInfo = computed(() => is1pShop.value);

    const { spuList, isLoading, doRequest, reset, totalCount } = useProductsList({
      shopInfo,
      currentPage,
      search,
      spuAvailableParams,
      spuInStorefrontParams,
      useNewSearchApi,
      isNeedMutexInfo,
      sortParam,
      identity,
      location,
    });

    // 存在过滤条件
    const hasConditon = computed(
      () => search.value.value || !isEmpty(spuAvailableParams.value) || !isEmpty(spuInStorefrontParams.value),
    );

    // shop无商品
    const isEmptyShop = computed(() => spuList.value.length === 0 && !isLoading.value && !hasConditon.value);

    // 搜索结果为空
    const isSearchEmpty = computed(() => spuList.value.length === 0 && !isLoading.value && hasConditon.value);

    const { pageCount } = usePageCount(totalCount);

    const { expandedRows, expandRow, expandRowKeys } = useExpandRow();

    const { selectedSpuSet, selectChange, selectAllChange, selectNumLimit } = useSelectRow({
      selectedSpuList,
      currentPageSpuList: spuList,
      adgroupData,
      campaignData,
      isSingleSelect,
    });

    const handleSort = (key, reverse) => {
      sortParam.value = {
        sort_order: reverse === 1 ? 0 : 1,
        sort_field: SORT_FIELD_MAP[key] || SORT_FIELD_MAP.default,
      };
    };

    const pageSize = computed(() => (useNewSearchApi.value ? PRODUCTS_PSA_MAX_NUM : PRODUCTS_MAX_NUM));

    return {
      name,
      spuList,
      isLoading,
      totalCount,
      currentPage,
      pageCount,
      handlePageChange,
      search,
      fieldList,
      spuAvailableFilter,
      spuAvailableFilterChange,
      spuAvailableParams,
      inStorefrontFilter,
      inStorefrontFilterChange,
      spuInStorefrontParams,
      expandedRows,
      expandRow,
      expandRowKeys,
      selectedSpuSet,
      selectChange,
      selectAllChange,
      selectNumLimit,
      isSearchEmpty,
      isEmptyShop,
      useNewSearchApi,
      handleSort,
      sortParam,
      pageSize,
      is1pShop,
    };
  },
});
